import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Grid } from '@mui/material'
import _ from "lodash"
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Loading from "./Loading";
import DynamicComponent from "./partials/DynamicComponent";
import '../styles/report.css'



const AdminReport = (props) => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)

    const [searchParams] = useSearchParams();
    const { viewInstance, settings } = useSelector(state => state.viewinstance)

    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {
        //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
        if ((!viewInstance || !viewInstance.ReportViewInstance) && !callVI) {
            //SO IT'S NOT CALLED MULTIPLE TIMES
            setCallVI(true)
            //CALL THE ACTION THAT FETCHES THE SERVICE AND UPDATES THE STATE
            dispatch(getViewInstance(searchParams.get("vi"), currentUser.AuthToken))
        }
        //WINDOW.LOCATION PROVIDES EXTRA CONTEXT SO WHEN TEH URL UPDATES THE APP UPDATES
    }, [window.location.pathname])

/**
 * View instance return
 * ReportViewInstance:{
 *  ReportPage:[
 *      ReportFrame:[
 *          {"Visible":"1/0","Order":"","ComponentType":""}
 *          , {"Visible":"1/0","Order":"","ComponentType":""}
 *          , {"Visible":"1/0","Order":"","ComponentType":""}
 *          , {"Visible":"1/0","Order":"","ComponentType":""}
 *      ]
 *  ]
 * }
 */
    if (viewInstance && viewInstance.ReportViewInstance) {
 
        const OrderedSections = viewInstance.ReportViewInstance.ReportPage[0].ReportFrame.sort(function (a,b){return parseInt(a.Order) - parseInt(b.Order)})

        
        return (
            <div>

                <Grid container direction ="row" spacing={1} sx={{ marginTop: '150px', marginLeft: '-12px' }} alignItems="top" justifyContent="center">

                    {/** The idea is simple, we will send each array to a single component that will dictate its format */}
                    {/** Each array will have a ComponentType attribute. [{ComponentType},{ComponentType},{ComponentType}] */}
                    {/** This component type will load a specific component*/}

                    {
                        OrderedSections.map((reportComponent, index) => {
                            return (

                                <DynamicComponent component={reportComponent} delay={index} key={index} />

                            )
                        })
                    }


                </Grid>
            </div>
        );
    } else {
        return <div>
            <Loading />
        </div>
    }


};

export default AdminReport;